import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5e396378")

_pushScopeId("data-v-5e396378")
const _hoisted_1 = { class: "flex flex-col gap-4 px-3 py-5 rounded-xl border border-gray-lp-1300" }
const _hoisted_2 = { class: "w-full flex flex-row gap-4 content-center" }
const _hoisted_3 = { class: "flex flex-grow" }
const _hoisted_4 = { class: "flex flex-row gap-4 px-6 py-2 rounded-xl bg-gray-lp-1000 content-center" }
const _hoisted_5 = { class: "font-semibold text-lp-gray-300 content-center" }
const _hoisted_6 = { class: "content-center" }
const _hoisted_7 = { class: "flex flex-col gap-4" }
const _hoisted_8 = { class: "w-full flex flex-row gap-4" }
const _hoisted_9 = { class: "w-full flex-1" }
const _hoisted_10 = { class: "w-full flex-1" }
const _hoisted_11 = {
  class: "w-full flex flex-row gap-4 flex-1 client-address-input",
  style: {"flex":"1"}
}
const _hoisted_12 = {
  class: "flex flex-col gap-3",
  style: {"flex":"1"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_ToggleV2 = _resolveComponent("ToggleV2")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Title, {
            class: "content-center",
            fontSize: 20,
            label: _ctx.$t('clientManagement.registrationBranchForm.sttReturn.title')
          }, null, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("clientManagement.registrationBranchForm.sttReturn.sameAsBranchClientDetail")), 1),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_ToggleV2, {
              onClick: _cache[1] || (_cache[1] = () => _ctx.autoFill()),
              "model-value": _ctx.isFill,
              "style-active": _ctx.toggle-_ctx.active
            }, null, 8, ["model-value", "style-active"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_DataWrapper, {
              asterisk: "",
              label: _ctx.$t('clientManagement.registrationBranchForm.sttReturn.receiverName'),
              fontSize: 14
            }, {
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  placeholder: _ctx.$t('clientManagement.registrationBranchForm.clientBranch.enterClientName'),
                  modelValue: _ctx.modelValue.receiverName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue.receiverName = $event)),
                  error: _ctx.error.codRejClientName,
                  disabled: _ctx.isFill
                }, null, 8, ["placeholder", "modelValue", "error", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.registrationForm.contact.phone'),
              fontSize: 14,
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  placeholder: "Contoh: 8123456789012",
                  prefix: _ctx.phoneCodePrefix,
                  format: _ctx.formatNumber,
                  debounce: 500,
                  error: _ctx.error.codRejPhone,
                  maxLength: "12",
                  errorCaption: "Masukan No. Telepon dengan benar",
                  modelValue: _ctx.modelValue.phone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.phone = $event)),
                  onChange: _ctx.validatePhone,
                  disabled: _ctx.isFill,
                  onSetPhone: _ctx.onSetCodPhone,
                  onSetPhoneCode: _ctx.onSetCodPhoneDialCode
                }, null, 8, ["prefix", "format", "error", "modelValue", "onChange", "disabled", "onSetPhone", "onSetPhoneCode"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('clientManagement.managementDetail.address'),
            fontSize: 14,
            asterisk: "",
            style: {"flex":"1"}
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                class: "w-full",
                type: "textarea",
                placeholder: _ctx.$t('clientManagement.registrationForm.parent.enterParentClientAddress'),
                modelValue: _ctx.modelValue.receiverAddress,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue.receiverAddress = $event)),
                disabled: _ctx.isFill
              }, null, 8, ["placeholder", "modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.managementDetail.districtCity'),
              fontSize: 14,
              asterisk: ""
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectSearch, {
                  class: "mt-2",
                  placeholder: _ctx.$t('clientManagement.registrationBranchForm.clientBranch.enterAndSelectDistrictCity'),
                  customValueStyle: "text-sm",
                  keyValue: "id",
                  isLoading: _ctx.loadingDistrictList,
                  options: _ctx.districtList,
                  modelValue: _ctx.modelValue.district,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.district = $event)),
                  onFilter: _ctx.fetchDistrictList,
                  error: _ctx.error.codRejDistrict,
                  isDisabled: _ctx.isFill
                }, null, 8, ["placeholder", "isLoading", "options", "modelValue", "onFilter", "error", "isDisabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ])
    ])
  ]))
})